import { Buffer } from 'buffer';

import 'antd/dist/reset.css';
import 'pdfjs-dist/build/pdf.worker.min.mjs';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-multi-email/dist/style.css';

import '@/shared/i18n';
import './styles/legacy/styles.scss';
import './styles/styles.scss';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ConfigProvider } from 'antd';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { NotificationProvider } from '@/shared/ui/components';
import App from './App';
import { registerSharedDependencies } from './lib/registerSharedDependencies';

// Webpack's ProvidePlugin auto-injected a global `Buffer`; Vite does not.
// Restore it for code paths that call `Buffer.from(...)` without importing it.
globalThis.Buffer = Buffer;

registerSharedDependencies();

// index.html guarantees this element exists; the app cannot render without it.
const root = createRoot(document.getElementById('root')!);
root.render(
  <CacheProvider
    value={createCache({
      key: 'css',
      nonce: (window as any).__CSP_NONCE__,
    })}
  >
    <ConfigProvider
      csp={{ nonce: (window as any).__CSP_NONCE__ }}
      theme={
        {
          token: {
            colorPrimary: '#2265C6',
            borderRadius: 8,
            fontFamily: '"Cera Pro", Arial, Helvetica, sans-serif',
            colorBgTextHover: '#F5F7FA',
          },
          components: {
            Checkbox: {
              borderRadius: 4,
              borderRadiusSM: 4,
              borderRadiusLG: 4,
              borderRadiusXS: 4,
            },
            Tooltip: {
              borderRadius: 8,
              lineHeight: '22px',
              colorBgSpotlight: '#2F3845',
            },
            DatePicker: {
              cellActiveWithRangeBg: '#D9E7FA',
            },
            Select: {
              colorBgContainer: '#FBFBFB',
              colorBgContainerDisabled: '#EAEDF1',
              colorBorder: '#BCCCE0',
              colorTextDisabled: '#8492A6',
              borderRadius: 4,
            },
          },
        } as any
      }
    >
      <NotificationProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </NotificationProvider>
    </ConfigProvider>
  </CacheProvider>,
);
